export const municipalities = [
  { title: "København", value: 101 },
  { title: "Frederiksberg", value: 147 },
  { title: "Ballerup", value: 151 },
  { title: "Brøndby", value: 153 },
  { title: "Dragør", value: 155 },
  { title: "Gentofte", value: 157 },
  { title: "Gladsaxe", value: 159 },
  { title: "Glostrup", value: 161 },
  { title: "Herlev", value: 163 },
  { title: "Albertslund", value: 165 },
  { title: "Hvidovre", value: 167 },
  { title: "Høje-Taastrup", value: 169 },
  { title: "Lyngby-Taarbæk", value: 173 },
  { title: "Rødovre", value: 175 },
  { title: "Ishøj", value: 183 },
  { title: "Tårnby", value: 185 },
  { title: "Vallensbæk", value: 187 },
  { title: "Furesø", value: 190 },
  { title: "Allerød", value: 201 },
  { title: "Fredensborg", value: 210 },
  { title: "Helsingør", value: 217 },
  { title: "Hillerød", value: 219 },
  { title: "Hørsholm", value: 223 },
  { title: "Rudersdal", value: 230 },
  { title: "Egedal", value: 240 },
  { title: "Frederikssund", value: 250 },
  { title: "Greve", value: 253 },
  { title: "Køge", value: 259 },
  { title: "Halsnæs", value: 260 },
  { title: "Roskilde", value: 265 },
  { title: "Solrød", value: 269 },
  { title: "Gribskov", value: 270 },
  { title: "Odsherred", value: 306 },
  { title: "Holbæk", value: 316 },
  { title: "Faxe", value: 320 },
  { title: "Kalundborg", value: 326 },
  { title: "Ringsted", value: 329 },
  { title: "Slagelse", value: 330 },
  { title: "Stevns", value: 336 },
  { title: "Sorø", value: 340 },
  { title: "Lejre", value: 350 },
  { title: "Lolland", value: 360 },
  { title: "Næstved", value: 370 },
  { title: "Guldborgsund", value: 376 },
  { title: "Vordingborg", value: 390 },
  { title: "Bornholm", value: 400 },
  { title: "Middelfart", value: 410 },
  { title: "Christiansø", value: 411 },
  { title: "Assens", value: 420 },
  { title: "Faaborg-Midtfyn", value: 430 },
  { title: "Kerteminde", value: 440 },
  { title: "Nyborg", value: 450 },
  { title: "Odense", value: 461 },
  { title: "Svendborg", value: 479 },
  { title: "Nordfyns", value: 480 },
  { title: "Langeland", value: 482 },
  { title: "Ærø", value: 492 },
  { title: "Haderslev", value: 510 },
  { title: "Billund", value: 530 },
  { title: "Sønderborg", value: 540 },
  { title: "Tønder", value: 550 },
  { title: "Esbjerg", value: 561 },
  { title: "Fanø", value: 563 },
  { title: "Varde", value: 573 },
  { title: "Vejen", value: 575 },
  { title: "Aabenraa", value: 580 },
  { title: "Fredericia", value: 607 },
  { title: "Horsens", value: 615 },
  { title: "Kolding", value: 621 },
  { title: "Vejle", value: 630 },
  { title: "Herning", value: 657 },
  { title: "Holstebro", value: 661 },
  { title: "Lemvig", value: 665 },
  { title: "Struer", value: 671 },
  { title: "Syddjurs", value: 706 },
  { title: "Norddjurs", value: 707 },
  { title: "Favrskov", value: 710 },
  { title: "Odder", value: 727 },
  { title: "Randers", value: 730 },
  { title: "Silkeborg", value: 740 },
  { title: "Samsø", value: 741 },
  { title: "Skanderborg", value: 746 },
  { title: "Aarhus", value: 751 },
  { title: "Ikast-Brande", value: 756 },
  { title: "Ringkøbing-Skjern", value: 760 },
  { title: "Hedensted", value: 766 },
  { title: "Morsø", value: 773 },
  { title: "Skive", value: 779 },
  { title: "Thisted", value: 787 },
  { title: "Viborg", value: 791 },
  { title: "Brønderslev", value: 810 },
  { title: "Frederikshavn", value: 813 },
  { title: "Vesthimmerland", value: 820 },
  { title: "Læsø", value: 825 },
  { title: "Rebild", value: 840 },
  { title: "Mariagerfjord", value: 846 },
  { title: "Jammerbugt", value: 849 },
  { title: "Aalborg", value: 851 },
  { title: "Hjørring", value: 860 },
];

export const municipalitiesMap = new Map<string, string>(
  municipalities.map((municipality) => [
    municipality.value.toString(),
    municipality.title,
  ]),
);
